import { ShieldAlert, Clock } from "lucide-react";

export const EmailBlacklistsHeroSection = () => {
  return (
    <section className="pt-24 sm:pt-28 pb-8 sm:pb-10">
      <div className="text-center max-w-4xl mx-auto px-4">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-medium mb-6">
          <ShieldAlert className="w-4 h-4" />
          Email Deliverability
        </div>

        <h1 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold text-foreground mb-4 leading-tight">
          Email Blacklists Explained
        </h1>

        <p className="text-lg sm:text-xl text-muted-foreground mb-6 max-w-2xl mx-auto">
          Most senders misunderstand what blacklists are, who actually uses them, and which
          listings matter. Here is how the ecosystem really works.
        </p>

        <div className="flex items-center justify-center gap-4 text-sm text-muted-foreground">
          <span className="flex items-center gap-1.5">
            <Clock className="w-4 h-4" />
            9 min read
          </span>
          <span>•</span>
          <span>Spamhaus, SURBL, and what actually affects deliverability</span>
        </div>

        <div className="grid grid-cols-3 gap-4 mt-10 max-w-lg mx-auto">
          <div className="bg-card rounded-xl border border-border p-4">
            <p className="text-2xl sm:text-3xl font-bold text-primary">100+</p>
            <p className="text-xs text-muted-foreground mt-1">public blacklists exist</p>
          </div>
          <div className="bg-card rounded-xl border border-border p-4">
            <p className="text-2xl sm:text-3xl font-bold text-warning">2</p>
            <p className="text-xs text-muted-foreground mt-1">truly matter for major providers</p>
          </div>
          <div className="bg-card rounded-xl border border-border p-4">
            <p className="text-2xl sm:text-3xl font-bold text-success">0</p>
            <p className="text-xs text-muted-foreground mt-1">public blacklists used directly by Gmail</p>
          </div>
        </div>
      </div>
    </section>
  );
};